export const PROPOSAL_GET_LIST = "/proposal";
export const PROPOSAL_UPDATE_PERIOD = "/proposal/update/period";
export const PROPOSAL_INSERT_PRODUCT = "/proposal/insert/product";
export const PROPOSAL_UPDATE_PRODUCT = "/proposal/update/product";
export const PROPOSAL_CHECK_CONFLICT = "/proposal/check";
export const PROPOSAL_CHECK_PARTNER_CONFLICT = "/proposal/check/partner";
export const PROPOSAL_PRODUCTS_FILTER = "/proposal/product/filter";
export const PROPOSAL_PARTNER_FILTER = "/proposal/partner/filter";
export const PROPOSAL_INSERT_PARTNER = "/proposal/insert/partner";